import type { CareActionSectionGroup } from '@/components/CareActions/careActionSection'
import type { CareActionItem } from '@/types/interfaces/careActions'
import { careActionKindSections, careActionSections } from '@/components/CareActions/careActionSection'

export type CompletedStep = 'prescription' | 'lab'

export interface CarePlanNextStepsCopy {
    remainingMessage: string
    caughtUpMessage: string
    returnAction: string
    completed: Record<CompletedStep, { heading: string; body: string }>
    completionIcon: 'broken-check' | 'check-spot'
    landOnNextSteps: boolean
    followUpAction: string
    followUpDateFormat: string | null
    labsTitle: string
    bookLabsAction: string
}

/** Replaces the curation badge on care plan items while options are being found; null keeps the badge. */
export interface CarePlanCurationCopy {
    label: string
    body: string
    referralBody: string
    iconSrc: string
}

export interface CarePlanCopy {
    grouping: 'lifecycle' | 'kind'
    curation: CarePlanCurationCopy | null
    providerHeadshotSize: number
    questionsHeading: string
    questionsBody: string
    nextSteps: CarePlanNextStepsCopy
}

export const generalMedicineCarePlanCopy: CarePlanCopy = {
    grouping: 'lifecycle',
    curation: null,
    providerHeadshotSize: 64,
    questionsHeading: '',
    questionsBody: '',
    nextSteps: {
        remainingMessage: "Nice work! Let's tackle your next step:",
        caughtUpMessage: "You're all caught up — we're working on more next steps.",
        returnAction: 'Return to care plan',
        completed: {
            prescription: { heading: '', body: '' },
            lab: { heading: '', body: '' },
        },
        completionIcon: 'broken-check',
        landOnNextSteps: false,
        followUpAction: 'Schedule visit',
        followUpDateFormat: null,
        labsTitle: 'Book {count} {noun}',
        bookLabsAction: 'Book labs',
    },
}

export function carePlanSections(
    actions: CareActionItem[],
    grouping: CarePlanCopy['grouping'],
): CareActionSectionGroup[] {
    return grouping === 'kind' ? careActionKindSections(actions) : careActionSections(actions)
}
